import { useEffect } from 'react';
import {
  useCompanyScanDispatch,
  useCompanyScanSelector,
} from '../../../../../../../../common/src/utils/globalVariables';
import { setQueuedScrollId } from '../../../../../../../../company-scan/store/redux/slices/companyScanSlice';
import {
  FlowsQuestion,
  FlowsQuestionGroup,
} from '../../../../../../types/FlowsTypes';
import { scrollToId } from '../../../utils/helperFunctions';

const useListenForScroll = (
  groupOrQuestion: FlowsQuestionGroup | FlowsQuestion,
): void => {
  const queuedScrollId = useCompanyScanSelector(
    (state) => state.companyScan.queuedScrollId,
  );
  const companyScanDispatch = useCompanyScanDispatch();

  useEffect(() => {
    /**
     * This effect will check if any scroll id was queued.
     * If that is the case it will scroll and clear the queue.
     */
    if (groupOrQuestion.id === queuedScrollId) {
      scrollToId(groupOrQuestion);
      companyScanDispatch(setQueuedScrollId(''));
    }
  }, [queuedScrollId]);
};

export default useListenForScroll;
